import { render, staticRenderFns } from "./PrivacyPolicyEN.vue?vue&type=template&id=3bf132ab&scoped=true"
import script from "./PrivacyPolicyEN.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyEN.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyEN.vue?vue&type=style&index=0&id=3bf132ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf132ab",
  null
  
)

export default component.exports